import { createContext, useContext, useState, useEffect } from 'react';
import API from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tokens = JSON.parse(localStorage.getItem('tokens'));
    if (tokens?.access) {
      API.get('profile/')
        .then((res) => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('tokens');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    try {
      const { data } = await API.post('auth/login/', { username, password });
      console.log('Login response:', data);
      localStorage.setItem('tokens', JSON.stringify(data));
      const profile = await API.get('profile/');
      console.log('Profile response:', profile.data);
      setUser(profile.data);
      return profile.data;
    } catch (err) {
      console.error('Login error:', err);
      throw err;
    }
  };

  const register = async (formData) => {
    await API.post('auth/register/', formData);
    return await login(formData.username, formData.password);
  };

  const logout = () => {
    localStorage.removeItem('tokens');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
